export default [
    {
        title: 'مدیریت پروژه ها',
        icon: 'bx bx-chalkboard',
        children: [
            {
                title: 'پروژه ها',
                route: { name: 'project' },
                resource: 'ProjectManager',
                action: 'show',
            },
            {
                title: 'دسته بندی ها',
                route: { name: 'projectcategory' },
                resource: 'ProjectCategoryManager',
                action: 'show',
            },
        ],
    },
]
